import { FeatureFlagListPage, FeatureFlagEditPage, FeatureFlagCreatePage } from './imports';

export const featureFlagRoutes = [
  {
    path: 'feature-flags',
    children: [
      { element: <FeatureFlagListPage />, index: true },
      { path: 'new', element: <FeatureFlagCreatePage /> },
      { path: ':id/edit', element: <FeatureFlagEditPage /> },
    ],
  },
];
